/**
 * 用于 onebox 子页面调整 iframe 高度
 */

const Onebox = {
  resetIframeWrapperHeight(id, height) {
    try{
      document.getElementById(`onebox-iframe-wrapper-${id}`).style.height = height + "px";
    } catch(e){}
  },
  resetIframeHeight (id, height){
    try{
      document.getElementById(`onebox-iframe-inner-wrapper-${id}`).style.height = height + "px";
      document.getElementById(`onebox-iframe-${id}`).style.height = height + "px"
    } catch(e){}
  }
}

window.Onebox = Onebox;
export default Onebox;